import { PktBreadcrumbs } from '..'

export default function Breadcrumb() {
  const breadcrumbs = [
    {
      href: '#1',
      text: 'Nivå 1',
    },
    {
      href: '#2',
      text: 'Nivå 2',
    },
    {
      href: '#3',
      text: 'Nivå 3',
    },
    {
      href: '#4',
      text: 'Nivå 4',
    },
    {
      href: '#5',
      text: 'Nivå 5',
    },
  ]

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Breadcrumbs</h1>

        <section className="component">
          <h2>Som lenker</h2>
          <PktBreadcrumbs breadcrumbs={breadcrumbs} />
        </section>
        <section className="component">
          <h2>Som React Router-lenker</h2>
          <PktBreadcrumbs breadcrumbs={breadcrumbs} navigationType="router" />
        </section>
      </main>
    </>
  )
}
